import {
  assignTransportsToCustomer,
  getCslInfo,
  getCustLocationInfo,
  getRequestInfo,
  getRouteInfo,
  getRunInfo,
  getScheduleDate,
  rescheduleRequests
} from "services/common";
import { TAG_TYPES } from "utils/constants";
import { dataDogErrorLog, handleRefId } from "utils/helpers";
import { baseApi } from "../baseApi";

/**
 * @module rescheduleServiceApi reschedule service RTK Query endpoints
 */
export const rescheduleServiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getScheduleDate: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getScheduleDate(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/returnrequestidandscheduleddateforcustomer`,
            {
              main_district_id: props.mainDistrictId,
              customer_id: props.customerId,
              from_date: props.fromDate,
              to_date: props.toDate,
              reschedule_flag: props.rescheduleFlag,
              addon_cutoff_flag: props.addonCutoffFlag,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.scheduleDate]
    }),

    getCustLocationInfo: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getCustLocationInfo(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/getserviceauthcomments`,
            {
              main_district_id: props.mainDistrictId,
              customer_id: props.customerId,
              exchange_location_type_code: props.exchangeLocationTypeCode,
              service_frequency_flag: props.serviceFrequencyFlag,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.custLocationInfo]
    }),
    getRequestInfo: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getRequestInfo(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/getsinglerequestdata`,
            {
              main_district_id: props.mainDistrictId,
              request_id: props.requestId,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.requestInfo]
    }),
    getCslInfo: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getCslInfo(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/geteligiblecsl`,
            {
              main_district_id: props.mainDistrictId,
              customer_id: props.customerId,
              reschedule_date: props.rescheduleDate,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.cslInfo]
    }),
    getRouteInfo: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getRouteInfo(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/geteligiblecustomerservicelocations`,
            {
              main_district_id: props.mainDistrictId,
              customer_id: props.customerId,
              reschedule_date: props.rescheduleDate,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.routeInfo]
    }),
    getRunInfo: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await getRunInfo(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/getserviceinfoforrequestonrun`,
            {
              main_district_id: props.mainDistrictId,
              request_id: props.requestId,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.runInfo]
    }),
    assignTransportsToCustomer: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await assignTransportsToCustomer(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/assigndistricttransportstocustomer`,
            {
              main_district_id: props.mainDistrictId,
              request_id: props.requestId,
              employee_id: props.employeeId,
              sf_assign_code: props.sfAssignCode,
              sf_remove_code: props.sfRemoveCode,
              request_transport: props.requestTransport,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.assignTransportsToCustomer]
    }),
    rescheduleRequests: builder.mutation({
      queryFn: async (props) => {
        try {
          const response = await rescheduleRequests(props);
          return {
            data: response
          };
        } catch (err) {
          const { refId, message } = handleRefId(err);
          dataDogErrorLog(
            message,
            `${process.env.REACT_APP_CF_URL_MODULE_REQUEST}/request/reschedulerequests`,
            {
              main_district_id: props.mainDistrictId,
              csl_customer_id: props.cslCustomerId,
              old_service_date: props.oldServiceDate,
              new_service_date: props.newServiceDate,
              personnel_id: props.personnelId,
              employee_id: props.employeeId,
              holiday_flag: props.holidayFlag,
              csl_new_rcs_id: props.cslNewRcsId,
              csl_new_request_id: props.cslNewRequestId,
              last_mod_user: props.lastModUser,
              rescheduled_to_text: props.rescheduledToText,
              rescheduled_from_text: props.rescheduledFromText,
              error: err
            },
            refId
          );
          return { error: message };
        }
      },
      providesTags: [TAG_TYPES.rescheduleRequests]
    })
  })
});
